export default function offsetBlockClass(blockType, defaultClass) {
  switch (blockType) {
    case 'single-block':
      return 'single-offset';
    case 'multi-block':
      return 'multi-offset';
    default:
      return defaultClass;
  }
}
